/*eslint-disable*/
import React from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { makeStyles } from "@material-ui/core/styles";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Icon from "@material-ui/core/Icon";
import { FiPhoneCall } from "react-icons/fi";
import Header from "components/Header/Header.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import loginPageStyle from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";

import image from "assets/img/bg7.jpg";

const useStyles = makeStyles(loginPageStyle);

export default function BanglesLogin() {
    const [mobile, setMobile] = React.useState("");
    const [mobileErr, setMobileErr] = React.useState("");
    const [otpNumber, setOtpNumber] = React.useState("");
    const [otpNumberErr, setOtpNumberErr] = React.useState("");
    const [otpScreen, setOtpScreen] = React.useState(false);
    const [otp, setOtp] = React.useState("");
    const [reSend, setReSend] = React.useState("");

    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });

    const classes = useStyles();
    const history = useHistory();
    // const headApi = `https://api.bangles.org.in/api/rest`;

    // const currentSession = sessionStorage.getItem("sessionData");
    // {currentSession ? history.push("/product-list") : history.push("/bangles-login")}
    // if (currentSession) {
    //   history.push("/product-list");
    // }

    const handleSendOtp = () => {
        let errorCount = 0;
        if (!mobile || mobile.length < 12) {
            errorCount++;
            setMobileErr("Please Enter 10 digit Mobile Number");
        }
        if (errorCount === 0) {
            fetch(headApi + `/user/sendotp?mobile=+${mobile}&type=client&webappid=6`, {
                method: "PUT"
                // headers: {
                //     "content-type": "application/json",
                //     accept: "application/json",
                // },
            })
                .then((response) => response.json())
                .then((response) => {
                    // console.log(response);
                    if (response.message === "Enter Registerd Mobile number") {
                        setMobileErr("Please Enter Valid Mobile Number");
                    }
                    if (response && response.error === "false") {
                        setOtpScreen({ otpScreen: true });
                        setOtp(response.message);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleOtp = (e) => {
        setOtpNumber(e.target.value);
        setOtpNumberErr("");
    }


    const handleLogin = () => {
        let errCount = 0;
        if (otpNumber.length !== 6) {
            errCount++;
            setOtpNumberErr("Invalid OTP");
        }

        if (errCount === 0) {
            fetch(
                headApi + `/user/login?otp=${otpNumber}&mobile=+${mobile}&type=client`,
                {
                    method: "PUT"
                    // headers: {
                    //     "content-type": "application/json",
                    //     accept: "application/json",
                    // },
                }
            )
                .then((response) => response.json())
                .then((response) => {
                    // console.log(response);
                    if (response.apiResponse.error !== "false") return false;
                    const userObj = response.user;
                    // localStorage.setItem("userObj", JSON.stringify(userObj));
                    sessionStorage.setItem("sessionData", JSON.stringify(userObj));
                    history.push("/product-list");
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleCall = (e) => {
        e.preventDefault();
        fetch(headApi + `/user/callMe?mobile=+${mobile}&webappid=6`, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                accept: "application/json",
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (response === "Thank You for Visiting! We will reach back to you soon.") {
                    alert("Thank You for Visiting! We will reach back to you soon.");
                    }
            });

    }

    return (
        <div>
            <Helmet>
                <title>Bangles Log In</title>
            </Helmet>
            <Header
                fixed
                color="transparent"
                brand="Home"
            // links={<HeaderLinks dropdownHoverColor="info" />}
            />
            <div
                className={classes.pageHeader}
            // style={{
            //     backgroundImage: "url(" + image + ")",
            //     backgroundSize: "cover",
            //     backgroundPosition: "top center",
            // }}
            >
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={4}>
                            <Card>
                                {!otpScreen ? (
                                    <form className={classes.form}>
                                        <CardHeader
                                            color="info"
                                            signup
                                            className={classes.cardHeader}
                                        >
                                            <h4 className={classes.cardTitle}>Login</h4>
                                            <div className={classes.socialLine}>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    <i className="fab fa-twitter" />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    <i className="fab fa-facebook" />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    <i className="fab fa-google-plus-g" />
                                                </Button>
                                            </div>
                                        </CardHeader>
                                        <p className={classes.description + " " + classes.textCenter}>
                                            Welcome
                                        </p>
                                        <CardBody signup>
                                            <PhoneInput
                                                // style={mystyle}
                                                inputStyle={{
                                                    width: "100%",
                                                    border: "none",
                                                    borderBottom: "1px solid #040000 ",
                                                    borderRadius: "0",
                                                }}
                                                country={"in"}
                                                name="mobile"
                                                value={mobile}
                                                // onChange={(mobile) => handleMobileNumber(mobile)}
                                                onChange={(mobile) => {
                                                    setMobile(mobile.length <= 12 ? mobile : mobile);
                                                    setMobileErr("");
                                                }}
                                                required={true}
                                            />
                                            <span style={{ color: "red" }}>{mobileErr}</span>
                                        </CardBody>
                                        <br />
                                        <div className={classes.textCenter}>
                                            <Button simple color="info" size="lg" onClick={handleSendOtp}>
                                                Log in with OTP
                                            </Button>
                                        </div>
                                        <div className={classes.textCenter}>
                                            <Button simple color="info" size="lg" href="/bangles-sign-up">
                                                Create New Account
                                            </Button>
                                        </div>
                                    </form>
                                ) : (
                                    <form className={classes.form}>
                                        <CardHeader></CardHeader>
                                        <br />
                                        <p className={classes.description + " " + classes.textCenter}>
                                            6 digit OTP SMS sent on your mobile
                                        </p>
                                        <p className={classes.description + " " + classes.textCenter}>{otp}</p>
                                        <p className={classes.description + " " + classes.textCenter}>{reSend}</p>
                                        <CardBody signup>
                                            <CustomInput
                                                id="otpNumber"
                                                formControlProps={{
                                                    fullWidth: true,
                                                }}
                                                inputProps={{
                                                    name: "otpNumber",
                                                    value: otpNumber,
                                                    onChange: (e) => handleOtp(e),
                                                    placeholder: "Enter OTP here",
                                                    type: "text",
                                                    // endAdornment: (
                                                    //     <InputAdornment position="end">
                                                    //         <Icon className={classes.inputIconsColor}>
                                                    //             lock_utline
                                                    //         </Icon>
                                                    //     </InputAdornment>
                                                    // ),
                                                    autoComplete: "off",
                                                }}
                                                required={true}
                                            />
                                            <p className={classes.description + " " + classes.textCenter}>{otpNumberErr}</p>
                                        </CardBody>

                                        <div className={classes.textCenter}>
                                            <Button simple color="info" size="lg" onClick={handleLogin}>
                                                Log in
                                            </Button>
                                            <Button simple color="info" size="lg" onClick={handleCall}>
                                                <FiPhoneCall /> Call Me
                                            </Button>
                                        </div>
                                        <p className={classes.description + " " + classes.textCenter}> Didn't receive the OTP yet? <span style={{ marginLeft: "10px" }}><a href="#" onClick={handleSendOtp}>Resend OTP</a></span></p>
                                    </form>
                                )}
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>

            </div>
        </div>
    );
}
